import { Box } from '@mui/material';
import { ClientStepProps } from '../../types';
import { formatAmount } from '../../../common/components/dataGrid/dataGridEditNumberCell';
import { getFormattedDate } from '../../../common/lib/date';
import { JSX } from 'react';
import { LegalEntity } from '../../../common/types/client';
import PolicyCard from '../../../common/components/policyCard';

/**
 * Legal entity details step
 */
const DetailsStep = ({ client }: ClientStepProps<LegalEntity>): JSX.Element => {
  return (
    <Box>
      <PolicyCard
        sectionsClassName="grid md:grid-cols-2 gap-6"
        sections={[
          {
            topBorder: false,
            caption: 'Basic',
            items: [
              { name: 'Tax status', value: client.taxStatusNote },
              { name: 'Date established', value: getFormattedDate(client.dateEstablished) },
              { name: 'VAT number', value: client.vatNumber },
              { name: 'Tax number', value: client.taxNumber },
              { name: 'Language', value: client.language },
            ],
          },
          ...client.contacts.map(({ firstname, email, phone }) => ({
            topBorder: false,
            caption: 'Contact person',
            items: [
              { name: 'Name', value: firstname },
              { name: 'Phone number', value: phone },
              { name: 'Email address', value: email },
            ],
          })),
          {
            topBorder: false,
            caption: 'Addresses',
            items: client.addresses.map(({ street, city, province, country, code, typeNote }) => ({
              name: typeNote,
              value: `${street}, ${city}, ${province}, ${country}, ${code}`,
            })),
          },
          {
            topBorder: false,
            caption: 'Valuation',
            items: [
              { name: 'Type', value: client.valuation?.methodNote },
              { name: 'Basis', value: client.valuation?.basisNote },
              {
                name: 'Total valuation',
                value: formatAmount(client.valuation?.value || 0),
              },
            ],
          },
        ]}
      />
    </Box>
  );
};

export default DetailsStep;
